export default __webpack_public_path__ + "static/media/logo.ba02494f.svg";